import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  userName: string;

  lang: any = {};

  Profile = [
    // {
    //   value: 1,
    //   label: 'profile.myProfile',
    // },
    // {
    //   value: 2,
    //   label: 'profile.accountSetting',
    // },
    // {
    //   value: 3,
    //   label: 'profile.changePassword',
    // },
    // {
    //   value: 4,
    //   label: 'profile.privacyPolicy',
    // },
    {
      value: 4,
      label: 'profile.signOut',
    },
  ];

  optionsLanguages = [];
  languageselected;
  currentLanguage;
  langCountryLabel: any;
  constructor(
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private oauthService: OAuthService,
    private loginService: LoginService,
  ) {
    this.commonService.dynamicLanguage.subscribe(data => {
      if (data) {
        if (data.length != 0) {
          this.optionsLanguages = data
          this.lang.select = data[0].value;
          this.languageselected = data[0].label;
          this.currentLanguage = data[0].label;
          this.langCountryLabel = data[0].value;
          localStorage.setItem('language', data[0].value);
          this.translate.setDefaultLang(data[0].value);
          this.translate.use(data[0].value);
          this.commonService.loadhelpjson();
          this.commonService.dynamicLanguagelist([])
        }
      }
    })
  }

  ngOnInit(): void {
    //onInit
  }
  redirectHome(event: any) {
    if (event) {
      this.router.navigate(['/dashboard']);
    }
  }
  checkUrl(): boolean {
    if (this.route.snapshot['_routerState'].url == '/dashboard') {
      return true;
    } else {
      return false;
    }
  }
  doLogout(value) {
    if(!environment.SAME_DOMAIN){
      localStorage.clear();
      sessionStorage.clear();
     }
    let profile = value;
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      this.oauthService.logOut();
    }
    else if (profile == this.ON_CLOUD) {
      this.onCloudLogout();
    }
    // CAS environment
    else if (profile == this.ON_PREMISES_CAS) {
      this.onCASLogout();
    }
  }
  onCloudLogout() {
    if(this.loginService.userRoles!= undefined){
      if (this.loginService.userRoles.userRole.length > 1) {
        let logOut = environment.COGNITO.userProfileLogout;
        window.open(logOut, '_self');
      } else {
        let logOut = environment.COGNITO.logoutURL + "?client_id=" + environment.COGNITO.ClientId + "&logout_uri=" + environment.COGNITO.CAS_SERVER_URL + '?serviceurl=' + environment.COGNITO.landingLogout
        window.open(logOut, '_self');
      }
    }
  }
  onCASLogout() {
    if(this.loginService.userRoles!= undefined){
      if (this.loginService.userRoles.userRole.length > 1) {
        let logOutUrl =
        environment.OAUTH2_CAS.landingLogout
      window.open(logOutUrl, '_self');
      } else {
       let logOutUrl = environment.OAUTH2_CAS.logoutURL;
        window.open(logOutUrl, '_self');
      }
    }
  }

  onChangeLanguage(item) {
    this.lang.select = item.value;
    this.languageselected = item.label;
    this.currentLanguage = item.value;
    this.langCountryLabel = item.value;
    this.translate.setDefaultLang(item.value);
    this.translate.use(item.value);
    localStorage.setItem('language', item.value);
  }
  onChange(event) { }
  navigatetohome() {
    this.router.navigate(['/dashboard']);
  }
  getUserName() {
    let username = localStorage.getItem('profilename');
    if (username == undefined || username == null || username == '') {
      username = localStorage.getItem('userName')
    }
    return username;
  }
  profilename() {
    let username = localStorage.getItem('userName')
    return username;
  }
}
